import { AuthenticationDependenciesFactory } from "./dependencies.factory";

export const AuthenticationEpicsDependencies = {
    authenticationRepository: AuthenticationDependenciesFactory.getAuthenticationRepository()
}
